<template>
  <div class="hk-section">
    <slot name="title">
      <div class="hk-section-title-wrapper">
        <div class="hk-section-title">
          <i :class="icon"></i>
          <p>{{title}}</p>
        </div>
      </div>
    </slot>
    <div class="hk-section-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "section-panel",
  props: {
    title: String,
    icon: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
